/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style2 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _tpl = require('tpl');

var _tpl2 = _interopRequireDefault(_tpl);

var _reactRouter = require('react-router');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)('h1', {
  className: 'title'
}, void 0, '404');

var _ref2 = (0, _jsx3.default)('p', {
  className: 'desc'
}, void 0, '\u672A\u627E\u5230\u8BE5\u9875\u9762');

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);
    return (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));
  }

  (0, _createClass3.default)(Main, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: 'render',
    value: function render() {

      return (0, _jsx3.default)('div', {
        className: 'no-match'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'container'
      }, void 0, _ref, _ref2, (0, _jsx3.default)(_reactRouter.Link, {
        to: '/'
      }, void 0, ' ', (0, _jsx3.default)(_button2.default, {
        type: 'primary',
        style: { marginTop: 50 }
      }, void 0, '\u8FD4\u56DE\u9996\u9875'))));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: 'nomatch', //应用关联使用的redux
  component: Main, //接收数据的组件入口
  url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/nomatch/index.jsx
// module id = 1516
// module chunks = 0